module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAATCAYAAACk9eypAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADJJREFUeNpiZFjy8j8DAjAyEABMDCQCkjWwEOMMdA3/iVDHOAz8MBoP9PXDIMgPAAEGAH6pBsaNgvR4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/comp-title.png
// module id = VILV
// module chunks = 0